import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChainLink2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chain-link-2,url"} maskId="square-filled-radius-0-stroke-1-IconChainLink2"><path fillRule="evenodd" clipRule="evenodd" d="M1 6H9V7H2V17H9V18H1V6ZM15 6H23V18H15V17H22V7H15V6ZM6 11.5H18V12.5H6V11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChainLink2;
